import GokuDataGrid from '@/components/GokuDataGrid'
import { getPromoUses } from '@/modules/Promo/services'
import { useTranslation } from 'react-i18next'
import { GridColDef } from '@mui/x-data-grid'
import CellDate from '@/components/GokuDataGrid/CellDate'
import { Typogaphy, Title } from 'vnetwork-ui'
import { PromoUse } from '@/modules/Promo/types'
import CustomerIcons from '@/icons/CustomerIcons'

interface UsesProps {
    promoId: number
}

const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        maximumFractionDigits: 0,
    }).format(value)
}

const Uses: React.FC<UsesProps> = ({ promoId }) => {
    const { t } = useTranslation()

    const columns: GridColDef<PromoUse>[] = [
        {
            field: 'use_id',
            headerName: t('use_id'),
            width: 100,
            sortable: false,
        },
        {
            field: 'customer_id',
            headerName: t('customer_id'),
            width: 120,
            sortable: false,
        },
        {
            field: 'customer_name',
            headerName: t('customer_name'),
            flex: 1,
            minWidth: 180,
            sortable: false,
            renderCell: ({ row }) => (
                <Typogaphy>{row.customer_name || '-'}</Typogaphy>
            ),
        },
        {
            field: 'customer_email',
            headerName: t('email'),
            width: 200,
            sortable: false,
            renderCell: ({ row }) => (
                <Typogaphy>{row.customer_email || '-'}</Typogaphy>
            ),
        },
        {
            field: 'original_amount',
            headerName: t('original_amount'),
            width: 150,
            sortable: false,
            renderCell: ({ row }) => (
                <Typogaphy>
                    {row.original_amount
                        ? formatCurrency(row.original_amount)
                        : '-'}
                </Typogaphy>
            ),
        },
        {
            field: 'discount_amount',
            headerName: t('discount_amount'),
            width: 150,
            sortable: false,
            renderCell: ({ row }) => (
                <Typogaphy className="text-green-600 font-semibold">
                    -{formatCurrency(row.discount_amount)}
                </Typogaphy>
            ),
        },
        {
            field: 'final_amount',
            headerName: t('final_amount'),
            width: 150,
            sortable: false,
            renderCell: ({ row }) => (
                <Typogaphy>
                    {row.final_amount ? formatCurrency(row.final_amount) : '-'}
                </Typogaphy>
            ),
        },
        {
            field: 'order_id',
            headerName: t('order_id'),
            width: 100,
            sortable: false,
            renderCell: ({ row }) => (
                <Typogaphy>{row.order_id || '-'}</Typogaphy>
            ),
        },
        {
            field: 'used_at',
            headerName: t('used_at'),
            width: 160,
            sortable: false,
            renderCell: ({ row }) => <CellDate date={row.used_at} />,
        },
    ]

    return (
        <GokuDataGrid
            apiCall={(payload) => getPromoUses(promoId, payload)}
            columns={columns}
            reactQueryKey={`promo-uses-${promoId}`}
            dataGridProps={{
                getRowId: (row) => row?.use_id,
            }}
            options={{
                title: (
                    <Title
                        title="usage_history"
                        icon={() => (
                            <CustomerIcons className="text-bg-primary w-6 h-6" />
                        )}
                    />
                ),
                pageSize: 10,
                showSearch: false,
                showHideColumn: false,
            }}
        />
    )
}

export default Uses
